import { Resources } from 'constants/resources';

import { keepPreviousData } from '@tanstack/react-query';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { SortPayload, useListParams } from 'react-admin';
import { ListPage } from 'shared/react-admin/Pages';

import { OrderProviderExternalErrorsListContent } from './OrderProviderExternalErrorsListContent';

const PER_PAGE = 10;
const SORT: SortPayload = { field: 'createdAt,id', order: 'DESC' };

export const OrderProviderExternalErrorsList: React.FC = () => {
  const translate = useTypedTranslate();
  const [{ filterValues }] = useListParams({
    resource: Resources.OrderProviderExternalErrors,
    perPage: PER_PAGE,
    sort: SORT,
  });
  const isFiltersApplied = Object.keys(filterValues).length > 0;

  return (
    <ListPage
      empty={false}
      headerTitle={{
        titleText: translate('app.orderProviderExternalErrors.declineReasonAnalysis'),
      }}
      pagination={false}
      perPage={PER_PAGE}
      queryOptions={{
        enabled: isFiltersApplied,
        placeholderData: isFiltersApplied ? keepPreviousData : undefined,
      }}
      resource={Resources.OrderProviderExternalErrors}
      sort={SORT}
    >
      <OrderProviderExternalErrorsListContent />
    </ListPage>
  );
};
